import { Injectable } from '@angular/core';
import {ToastController} from "ionic-angular";

@Injectable()
export class ToastProvider {

  constructor(public toastCtrl: ToastController) {
  }

  public successToast(message_: string): void {
    let toast = this.toastCtrl.create({
      message: message_,
      duration: 2000,
      position: 'bottom',
      cssClass: "toast-success"
    });
    toast.present().catch();
  }

  public errorToast(message_: string): void {
    let toast = this.toastCtrl.create({
      message: message_,
      duration: 3000,
      position: 'bottom',
      cssClass: "toast-error",
      showCloseButton: true,
      closeButtonText: 'Ok'
    });
    toast.present().catch();
  }

}



// WEBPACK FOOTER //
// ./src/providers/toast/toast.ts